import React, { type ReactNode } from "react";
import { ThemeProvider } from "@material-ui/core/styles";

import { createAppTheme } from "src/theme";

/** Fixed default light theme for accountant / support portals (no dark or custom palettes). */
const lightTheme = createAppTheme("light");

function ForcedLightTheme({ children }: { children: ReactNode }) {
  return <ThemeProvider theme={lightTheme}>{children}</ThemeProvider>;
}

export default ForcedLightTheme;
